import { AxiosResponse } from 'axios';
import { api } from '@/services/api/axios/instance';
import { auth } from '@/constants';
import {
  RefreshTokenRequest,
  RevokeRequest,
  TokenRequest,
  TokenResponse,
} from '@/types/openid';

type PostRequestData = TokenRequest | RefreshTokenRequest;

export const tokensApi = {
  revoke: async (data: RevokeRequest): Promise<void> => {
    const config = { timeout: 10000 };
    await api.post(auth.Url.revokeUri, data, config);
  },
  post: async (data: PostRequestData): Promise<TokenResponse> => {
    const response: AxiosResponse<TokenResponse> = await api.post(
      auth.Url.tokenUri,
      data,
    );

    return response.data;
  },
};
